import { useQuery } from '@tanstack/react-query';
import { auditApi } from 'App';

export function useAnomalies(auditUUID: string) {
  return useQuery(['anomalies', auditUUID], () => auditApi.getAnomalies(auditUUID));
}
